export default class OrionError extends Error {
  constructor(message: string, cause?: Error) {
    super(message, { cause })

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    // @ts-ignore
    if (Error.captureStackTrace) {
      // @ts-ignore
      Error.captureStackTrace(this, OrionError)
    }

    this.name = 'OrionError'
  }
}
